import { useState, useRef } from 'react';
import YouTube from 'react-youtube';
import './main.css';
import './youtube.css';

const YoutubePlayer = () => {
    const playerRef = useRef(null);
    const [videoInfo, setVideoInfo] = useState({ url: localStorage.getItem('videoUrl') || 'https://www.youtube.com/watch?v=SrKi6WsZH74', id: localStorage.getItem('videoId') || 'vx2u5uUu3DE' });

    const onReady = (event) => {
        // プレーヤーのインスタンスを取得
        playerRef.current = event.target;
        
        // プレーヤーの音量を設定（0から100までの範囲）
        playerRef.current.setVolume(50); // 50は音量の値で、必要に応じて変更してください
    };

    const handleSetYoutubeUrl = async () => {
        const url = await navigator.clipboard.readText();
        setVideoInfo((prevVideoInfo) => {
            let newVideoInfo = { ...prevVideoInfo };
            newVideoInfo.url = url;
            newVideoInfo.id = extractYoutubeId(url);
            return newVideoInfo;
        });
        if(videoInfo.id !== null) {
            playerRef.current.loadVideoById(videoInfo.id);
            localStorage.setItem('videoId', videoInfo.id);
        }
    };

    const handleSetYoutubeVolume = (event) => {
        playerRef.current.setVolume(event.target.value);
    };

    const extractYoutubeId = (url) => {
        let result = null;

        // 末尾のスラッシュを削除
        if(url.endsWith('/')) {
            url = url.slice(0, -1);
        }

        // 末尾から "=" が出てくるまでの英数字を抽出
        const pattern = /([^=\/]+)$/;

        // 正規表現に一致するかを確認し、一致する場合は動画IDを抽出
        const match = url.match(pattern);

        if(match && match[1]) {
            result = match[1];
        }

        return result;
    };

    return (
        <div className="youtube">
            <div className="youtube_video">
                <div className="youtube_video_main">
                    <YouTube
                        videoId={videoInfo.id}
                        onReady={onReady}
                    />
                </div>
                <div className="youtube_video_volume">
                    <input type="range" min="0" max="100" onChange={handleSetYoutubeVolume}></input>
                    <img src="./volume.png" />
                </div>
            </div>
            <div className="youtube_url">
                <div className="btn_blue">
                    <button className="btn_url" onClick={handleSetYoutubeUrl}>クリップボードのURLを開く</button>
                </div>
                <div className="youtube_url_text">URL：{videoInfo.url}</div>
            </div>
        </div>
    );
};

export default YoutubePlayer;
